// export const transactionDriverHeaders = [
//   { label: 'Name', value: 'agentName', required: true, inputType: 'text' },
//   { label: 'Number', value: 'agentNumber', required: true, inputType: 'text' },
//   { label: 'Email', value: 'agentEmail', required: true, inputType: 'text' },
//   { label: 'Description', value: 'description', required: false, inputType: 'textarea' },
//   { label: 'Status', value: 'status', required: true, inputType: 'text' },
//   { label: 'Action', value: 'action', required: false, inputType: 'action' },
// ]


export const transactionDriverHeaders = [
  {
    label: 'id',
    value: 'transactionAgentId',
    Header: 'id',
    accessorKey: 'transactionAgentId',
    required: true,
    inputType: 'text',
    isShowModal: false,
  },

  {
    label: 'Name',
    value: 'agentName',
    Header: 'Name',
    accessorKey: 'agentName',
    required: true,
    inputType: 'text',
    isShowModal: true,
  },
  {
    label: 'Number',
    value: 'agentNumber',
    Header: 'Number',
    accessorKey: 'agentNumber',
    required: true,
    inputType: 'text',
    isShowModal: true,
  },
  {
    label: 'Email',
    value: 'agentEmail',
    Header: 'Email',
    accessorKey: 'agentEmail',
    required: true,
    inputType: 'text',
    isShowModal: true,
  },
  {
    label: 'Description',
    value: 'description',
    Header: 'Description',
    accessorKey: 'description',
    required: false,
    inputType: 'textarea',
    isShowModal: true,
  },
  {
    label: 'Status',
    value: 'status',
    Header: 'Status',
    accessorKey: 'status',
    required: false,
    inputType: 'text',
    isShowModal: true,
  },
  {
    label: 'Action',
    value: 'action',
    Header: 'Action',
    accessorKey: 'action',
    required: false,
    inputType: 'action',
    isShowModal: false,
  },
];
